import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "update-cloud-icon",
  "use": "update-cloud-icon-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 16\" id=\"update-cloud-icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 0a6.668 6.668 0 016.636 6.033 5.328 5.328 0 012.697 4.634A5.334 5.334 0 0116 16H5.333a5.334 5.334 0 010-10.667c.026 0 .051.002.076.004l.058.003A6.669 6.669 0 0112 0zm0 9V4h-2v5H8l3 4 3-4h-2z\" fill=\"#00AB44\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol